window.NotificationManagerAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.CorHrNotificationManagerServer);

    self.getNotificationSettings = function (brandId, params) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/notification_settings', 'GET', params)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateNotificationSettings = function (brandId, code, payload) {
        var defer = $q.defer();
        _protected
            .request('brands/' + brandId + '/notification_settings/' + code, 'PUT', payload)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.NOTIFICATIONS_SETTINGS_CODES = {
        EMPLOYEE_AVAILABILITY_REMINDER: "EMPLOYEE_AVAILABILITY_REMINDER",
    }
});
